import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getDayOfTheWeek } from '../../utils';
import './DayOfTheWeek.scss';

export const DayOfTheWeek = () => {
  const [date, setDate] = useState(() => new Date('1990-01-01'));
  const [weekDay, setWeekDay] = useState(() => getDayOfTheWeek(date));
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setWeekDay(() => getDayOfTheWeek(date));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [date]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Day of the Week Calculator</h2>
        <p className='mb-4'>
          Find out the day of the week given a certain date
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select a Date'
            initDate={date}
            setDate={setDate}
          />
          <button
            className='btn btn-success d-block w-100 py-2 fw-bold'
            onClick={calculate}
          >
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Result:</h4>
          <p className='mb-0' dangerouslySetInnerHTML={{ __html: weekDay }} />
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
